import React from 'react';

const TYPE_STYLES = {
  error: {
    background: '#fde8e8',
    color: '#c0392b',
    border: '1px solid #e74c3c',
  },
  warning: {
    background: '#fef3cd',
    color: '#7d5a00',
    border: '1px solid #f39c12',
  },
  success: {
    background: '#d4edda',
    color: '#155724',
    border: '1px solid #22C55E',
  },
};

export default function DriverToastContainer({ toasts }) {
  if (!toasts?.length) return null;

  return (
    <>
      <style>{`
        @keyframes driverSlideUp {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
      <div
        role="region"
        aria-label="Notificaciones"
        style={{
          position: 'fixed',
          bottom: 80,
          left: '50%',
          transform: 'translateX(-50%)',
          width: 'calc(100vw - 32px)',
          maxWidth: 360,
          zIndex: 9999,
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
          pointerEvents: 'none',
        }}
      >
        {toasts.map((t) => {
          const s = TYPE_STYLES[t.type] || TYPE_STYLES.warning;
          return (
            <div
              key={t.id}
              role="status"
              style={{
                ...s,
                borderRadius: 14,
                padding: '12px 16px',
                fontSize: 14,
                pointerEvents: 'auto',
                boxSizing: 'border-box',
                animation: 'driverSlideUp 0.3s ease-out both',
              }}
            >
              {t.message}
            </div>
          );
        })}
      </div>
    </>
  );
}
